import http from "./httpService";
import configdata from "./config.json";

let apiEndpoint = "";
if (process.env.NODE_ENV !== "production") {
    apiEndpoint = `${configdata.apiUrl}`;
} else {
    apiEndpoint = `${configdata.herokuUrl}`;
}


export async function userIsConfirmed(email, token) {
    const data = await http.get(
        `${apiEndpoint}/${email}/${token}`
    );
    return data;
}


export default {
    userIsConfirmed,
};
